import React, { FunctionComponent, ReactNode } from 'react';

type Props = {
	x?: number,
	y?: number,
	space?: number,
	width?: number,
	margin?: number,
	align?: string,
	children: any,
}

const LayoutList: FunctionComponent<Props> = ({
	x = 0,
	y = 0,
	space = 22,
	width = 100,
	margin = 0,
	align = "left",
	children,
}) => {

	const xAlign = align == "right" ? x - (width + margin) : x + margin

	return React.Children.map(children, (child, index) => {
		if (!React.isValidElement(child)) return
		return React.cloneElement<any>(child, {
			x: xAlign,
			y: y + index * space,
			width: width,
			height: space,
		});
	});
}

export default LayoutList
